export default "/assets/images/pm-png-sm.a2a9e922b133d422.png";